import React from 'react';
import { convertAmount } from '@pascal/pascal-core';

export function MobileFooterSection({ t, currencyCode, balance, lastWinAmount }) {
  return (
    <div className='tp-game-mobile-game-footer'>
      <div className='tp-g-mob-bal-wrp'>
        <div className='tp-g-mob-bal-item left'>
          <div className='tp-g-mob-bal-item-content'>
            <p className='tp-g-mob-bal-txt'>{t('BALANCE')}:</p>
            <p className='tp-g-mob-bal-number'>{convertAmount(balance)}</p>
            <p className='tp-g-mob-bal-usd'>{currencyCode}</p>
          </div>
        </div>
        <div className='tp-g-mob-bal-item right'>
          <div className='tp-g-mob-bal-item-content'>
            <p className='tp-g-mob-bal-txt'>{t('LAST_WIN')}:</p>
            <p className='tp-g-mob-bal-number'>{!!lastWinAmount && convertAmount(lastWinAmount)}</p>
            <p className='tp-g-mob-bal-usd'>{!!lastWinAmount && currencyCode}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
